import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type Theme = 'light' | 'dark'

interface Settings {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const useSettings = create<Settings>()(
  persist(
    (set, _get) => {
      return {
        theme: 'light',
        setTheme: (theme: 'light' | 'dark') => {
          set({ theme })
        },
      }
    },
    {
      name: 'settings',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

useSettings.persist.onHydrate(({ theme }) => {
  if (theme === 'light') {
    document.documentElement.classList.remove('dark')
  } else {
    document.documentElement.classList.add('dark')
  }
})

useSettings.subscribe((state) => {
  if (state.theme === 'light') {
    document.documentElement.classList.remove('dark')
  } else {
    document.documentElement.classList.add('dark')
  }
})

useSettings.persist.rehydrate()
